<template>
    <div class="Credits">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Credits__container column">
                <div class="row centered">
                    <div class="Credits__title">Thank you for watching.</div>
                </div>
                <div class="row bordered">
                    <div>
                        <div class="Credits__description">Link</div>
                        <div class="Credits__button"><img src="@/commons/images/link.png" class="Credits__iconlink">{{ window.location.origin }}</div>
                    </div>
                    <div class="bordered-left">
                        <div class="Credits__description">Socials</div>
                        <div>
                            <a href=""><img src="@/commons/images/facebook.png" class="Credits__icon"></a>
                            <a href=""><img src="@/commons/images/linkedin.png" class="Credits__icon"></a>
                            <a href=""><img src="@/commons/images/twitter.png" class="Credits__icon"></a>
                        </div>
                    </div>
                </div>
                <div class="row w-80">
                    <div class="Credits__button">Visit NFB site</div>
                    <div class="Credits__button">View film page</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'Credits',
    data: ()=>({

    }),  
    beforeDestroy() {

    },
    created(){

    },
    mounted() {

    },
    methods: {
        enter(done) { 
            done() 
        },
        leave(done) { 
            done() 
        },
    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Credits {
    position: absolute;
    z-index: 1000
    width:100%;
    max-width: 550px;

    &__container {
    }

    .row {
        width:100%
        display: flex;
        flex-direction: row;
        align-items: flex;
        justify-content: space-between;
        padding: 8px;

        &.centered {
            justify-content: center;
        }

        &.w {
            &-80 {
                width: 80%;
            }
        }

        &.bordered {
            border-top: 2px solid white;
            border-bottom: 2px solid white;
        }

        .bordered-left {
            border-left: 2px solid white;
            padding-left: 8px;
        }
    }

    .column {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__title {
        margin-bottom 18px
        font-size: 42px
        font-family: 'Ciutadella-Medium'
    }

    &__description {
        font-family: 'Ciutadella-Medium'
        font-size: 16px
    }

    &__button {
        text-align: center;
        font-family: 'Ciutadella-Medium'
        font-size: 20px
        text-decoration: none;
        background-color: white;
        color: black;
        border-style: solid
        border-color: white
        padding: 16px;
        padding-left: 32px;
        padding-right: 32px;
        display: inline-block;
        margin: 18px 2px;
        border-radius: 28px;
        z-index 5000
        text-align: center;
        display: flex;
    }

    &__icon {
        height: 62px
        padding-top: 16px;
    }

    &__iconlink {
        height: 24px
        // transform: translateY(6px);
        margin-right: 4px;
    }
}

</style>